import { useState, useEffect, useRef } from "react";
import { useRecoilValue } from "recoil";
import { ArrowDownIcon, PhoneIcon } from "../../../icons";
import { userInfo } from "../../../config/recoil/atoms";
import { UserMenu } from "./UserMenu";
import RingCentralWidget, { PresenceDot } from "../../../widgets/RingCentralWidget";

type IProps = {
    hide?: boolean;
};

export const User = ({ hide }: IProps) => {
    const info = useRecoilValue(userInfo);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const [toggled, setToggled] = useState(false);
    const [showRingCentralWidget, setShowRingCentralWidget] = useState(false);

    const [userStatus, setUserStatus] = useState<string>("Available");
    const [dndStatus, setDndStatus] = useState<string>("TakeAllCalls");

    const handleClickOutside = (event: any) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setToggled(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const combinedLabel = (userStatus: string, dndStatus: string) => {
        if (dndStatus === "DoNotAcceptAnyCalls") return "Do Not Disturb";
        return userStatus;
    };

    return (
        <>
            <div
                ref={wrapperRef}
                className="flex sm:gap-4 items-center relative cursor-pointer z-10"
                onClick={() => setToggled(!toggled)}
            >
                <img
                    src={info.profile_image}
                    alt="profile"
                    className="object-cover rounded-full w-[32px] h-[32px] sm:w-[30px] sm:h-[30px]"
                />
                <div
                    className={`flex gap-0 items-center gap-x-2 md:text-color7 ${toggled ? "text-color7" : "text-color8"
                        }`}
                >
                    {info.name && (
                        <span className="whitespace-nowrap text-sm font-inter md:flex hidden">
                            Hi, {info.name}!
                        </span>
                    )}
                </div>
                <UserMenu toggled={toggled} hide={hide} />
            </div>
            {/* <div
                className="flex items-center gap-2 cursor-pointer hover:bg-color3 p-1 rounded"
                onClick={e => {
                    e.stopPropagation();
                    setShowRingCentralWidget(true);
                }}
            >
                <PhoneIcon className="fill-current w-[18px]" />
                <PresenceDot status={combinedLabel(userStatus, dndStatus)} />
            </div>
            <RingCentralWidget
                open={showRingCentralWidget}
                onOpen={() => setShowRingCentralWidget(true)}
                onClose={() => setShowRingCentralWidget(false)}
                userStatus={userStatus}
                dndStatus={dndStatus}
                setUserStatus={setUserStatus}
                setDndStatus={setDndStatus}
            /> */}
        </>

    );
};
